import React from 'react'
import { Modal } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '@splidejs/react-splide/css';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import ldacap from '../../assets/images/logos/ldacap.png';
import Cross from '../../assets/images/icons/circle-cross.svg';
import Tick from '../../assets/images/icons/tick.svg';

const CaseStudies = ({show, close, modalText}) => {
    console.log("modalText",modalText);
    return (
        <Modal show={show} onHide={close} centered dialogClassName="modal-100w norounded">
            <Modal.Body className='p-0 position-relative'>
                
                <Link>
                    <img src={Cross} alt="close" className='position-absolute end-0 z-2 me-4 mt-4' onClick={() => close()} />
                </Link>
                {
                    modalText == "Financial" ?
                        <section className='py-5 bg-black'>
                        <div className="container py-5">
                        <div className="text-center mb-5 pb-3">
                            <h3 className='fs-17 mb-0'>MBD Financial District</h3>
                            <h2 className="title-h2 fw-bold px-md-5 gradient-text-1">Case Studies</h2>

                        </div>
                        <Splide aria-label="Comapany logos" options={{
                            pauseOnHover: true,
                            autoplay: true,
                            interval: 2500,
                            rewind: true,
                            wheel: true,
                            releaseWheel: true,
                            perPage: 4,
                            gap: '1rem',
                            arrows: false,
                            pagination: true,
                            autoplay: true,
                            pauseOnHover: false,
                            classes: {
                                pagination: 'splide__pagination pill-pagination',
                            },
                            breakpoints: {
                                575: {
                                    perPage: 2,
                                },
                                767: {
                                    perPage: 3,
                                }
                            },
                        }}>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>P2P Lending Platform</h5>
                                        <p className='mb-0 fs-12'>Without conventional financial middlemen, individuals can lend and borrow directly, making loans and investments more accessible.</p> 
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>MBD HybriDEX</h5>
                                        <p className='fs-12 mb-2'>Simplify. Amplify. Diversify. Cross-Chain Trading and Staking with an AI Advantage.</p>
                                        <p className='mb-0 fs-12'>It's a hybrid, the ideal fusion of the simplicity of a CEX and the creativity of a DEX, which is why we called it HybriDEX. Designed to make it easy for anyone, regardless of experience level, to navigate the world of DeFi.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Insurance Services</h5>
                                        <p className='mb-0 fs-12'>Smart contracts are used in innovative insurance products to enable more equitable, transparent, and effective claims processing.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>MBD Debit Cards</h5>
                                        <p className='mb-0 fs-12'>A means of bridging the gap between cryptocurrencies and fiat money by enabling users to make purchases using their virtual assets.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                        </Splide>
                        </div>
                        </section>
                    :""
                }
                {
                    modalText == "Boulevard" ?
                        <section className='py-5 bg-black'>
                        <div className="container py-5">
                        <div className="text-center mb-5 pb-3">
                            <h3 className='fs-17 mb-0'>MBD Boulevard</h3>
                            <h2 className="title-h2 fw-bold px-md-5 gradient-text-1">Case Studies</h2>

                        </div>
                        <Splide aria-label="Comapany logos" options={{
                        type: 'loop',
                        pauseOnHover: true,
                        autoplay: true,
                        interval: 2500,
                            rewind: true,
                            wheel: true,
                            releaseWheel: true,
                            perPage: 4,
                            gap: '1rem',
                            arrows: false,
                            pagination: true,
                            autoplay: true,
                            pauseOnHover: false,
                            classes: {
                                pagination: 'splide__pagination pill-pagination',
                            },
                            breakpoints: {
                                575: {
                                    perPage: 2,
                                },
                                767: {
                                    perPage: 3,
                                }
                            },
                        }}>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Phygital Fashion Frontier</h5>
                                        <p className='mb-0 fs-12'>Merging the digital and physical in fashion, creating a unique space for expression and innovation.</p> 
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Gaming and Digital Assets</h5>
                                        {/* <p className='fs-12'>Simplify. Amplify. Diversify. Cross-Chain Trading and Staking with an AI Advantage.</p> */}
                                        <p className='mb-0 fs-12'>Transforming how in-game assets are valued and traded, empowering gamers to own and profit from their digital experiences.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Art & Collectibles Redefined</h5>
                                        <p className='mb-0 fs-12'>Facilitating a diverse digital art and collectibles market, fostering creativity and authenticity.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Virtual Real Estate</h5>
                                        <p className='mb-0 fs-12'>Pioneering in digital land ownership, we're unlocking new potentials in virtual economies.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Phygital Real World Assets (RWA)</h5>
                                        <p className='mb-0 fs-12'>An innovative space for users to engage with, invest in, and grow the value of real-world assets in the photorealistic metaverse. By connecting traditional investments with
the dynamic possibilities of web3, we're crafting a future where every physical good gains a new dimension of value.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Phygital NFTs</h5>
                                        <p className='mb-0 fs-12'>Businesses, artists, and educators now have several options to explore as they can develop and profit from novel and inventive goods and services.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Membership NFTs</h5>
                                        <p className='mb-0 fs-12'>By giving members exclusive access and benefits, membership NFTs enable companies and organizations to provide their clients with exceptional and worthwhile experiences.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Ticketing Solution</h5>
                                        <p className='mb-0 fs-12'>Managing events and experiences giving businesses a simplified solution for ticket sales and management.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Reward Ecosystem</h5>
                                        <p className='mb-0 fs-12'>Allows users to get incentives for contributing, purchasing, and activity. Users can obtain tangible benefits by exchanging these rewards for real goods and services, and more.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                        </Splide>
                        </div>
                        </section>
                    :""
                }
                {
                    modalText == "Wellness" ?
                        <section className='py-5 bg-black'>
                        <div className="container py-5">
                        <div className="text-center mb-5 pb-3">
                            <h3 className='fs-17 mb-0'>MBD Wellness District</h3>
                            <h2 className="title-h2 fw-bold px-md-5 gradient-text-1">Case Studies</h2>

                        </div>
                        <Splide aria-label="Comapany logos" options={{
                        type: 'loop',
                        pauseOnHover: true,
                        autoplay: true,
                        interval: 2500,
                            rewind: true,
                            wheel: true,
                            releaseWheel: true,
                            perPage: 4,
                            gap: '1rem',
                            arrows: false,
                            pagination: true,
                            autoplay: true,
                            pauseOnHover: false,
                            classes: {
                                pagination: 'splide__pagination pill-pagination',
                            },
                            breakpoints: {
                                575: {
                                    perPage: 2,
                                },
                                767: {
                                    perPage: 3,
                                }
                            },
                        }}>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Record Monetization</h5>
                                        <p className='mb-0 fs-12'>By using blockchain technology, patients can manage and charge for access to their medical records while maintaining their privacy.</p> 
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Virtual Therapy Sessions</h5>
                                        <p className='mb-0 fs-12'>Connect with therapists for mental health support and counseling.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>AR/VR/MR Training</h5>
                                        <p className='mb-0 fs-12'>Using virtual and augmented reality simulations, medical professionals can receive advanced training.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Fitness Classes</h5>
                                        <p className='mb-0 fs-12'>oin virtual fitness classes tailored to various levels and preferences.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Health Education Seminars</h5>
                                        <p className='mb-0 fs-12'>Attend informative sessions on various health topics to empower yourself with knowledge.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Stress Management Programs</h5>
                                        <p className='mb-0 fs-12'>Participate in workshops and activities aimed at reducing stress and promoting relaxation.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Global Telemedicine</h5>
                                        <p className='mb-0 fs-12'>Services for providing remote medical care that connects patients with doctors anywhere in the world.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                        </Splide>
                        </div>
                        </section>
                    :""
                }
                {
                    modalText == "Education" ?
                        <section className='py-5 bg-black'>
                        <div className="container py-5">
                        <div className="text-center mb-5 pb-3">
                            <h3 className='fs-17 mb-0'>MBD Education District</h3>
                            <h2 className="title-h2 fw-bold px-md-5 gradient-text-1">Case Studies</h2>

                        </div>
                        <Splide aria-label="Comapany logos" options={{
                        type: 'loop',
                        pauseOnHover: true,
                        autoplay: true,
                        interval: 2500,
                            rewind: true,
                            wheel: true,
                            releaseWheel: true,
                            perPage: 4,
                            gap: '1rem',
                            arrows: false,
                            pagination: true,
                            autoplay: true,
                            pauseOnHover: false,
                            classes: {
                                pagination: 'splide__pagination pill-pagination',
                            },
                            breakpoints: {
                                575: {
                                    perPage: 2,
                                },
                                767: {
                                    perPage: 3,
                                }
                            },
                        }}>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Learn2Earn</h5>
                                        <p className='mb-0 fs-12'>Learning environments with an incentive component that rewards users for reaching learning objectives.</p> 
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Virtual Universities</h5>
                                        <p className='mb-0 fs-12'>Traditional universities can offer virtual courses within EduVerse, providing students with access to lectures, labs, and collaborative projects regardless of their physical location.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Skill Development Programs</h5>
                                        <p className='mb-0 fs-12'>Individuals can participate in immersive skill development programs tailored to various industries, such as coding boot camps, language learning courses, or digital marketing workshops.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Workforce Training</h5>
                                        <p className='mb-0 fs-12'>Employers can to provide training and upskilling opportunities to their employees, ensuring they remain competitive in rapidly evolving industries.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Entrepreneurial Incubation</h5>
                                        <p className='mb-0 fs-12'>Aspiring entrepreneurs can access resources and mentorship programs to develop their business ideas, collaborate with like-minded individuals, and launch startups in a supportive environment.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>DAOs for Education</h5>
                                        <p className='mb-0 fs-12'>Community-driven educational programs that permit group resource allocation and decision-making.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide>
                                <div className='d-flex flex-column gap-3 align-items-center'>
                                    <img src={Tick} alt="ldacap" width="62" height="62" />

                                    <div className='text-white text-center px-md-4 mt-2'>
                                        <h5 className='fw-semibold mb-2'>Certification and Credentialing</h5>
                                        <p className='mb-0 fs-12'>A platform for issuing and verifying digital credentials and certifications, providing individuals with a secure and transparent way to showcase their skills and qualifications.</p>
                                    </div>
                                </div>
                            </SplideSlide>
                        </Splide>
                        </div>
                        </section>
                    :""
                }
            </Modal.Body>
        </Modal>
    )
}

export default CaseStudies